import React from "react";
import * as S from "./styles";
export function FormOption(_ref) {
  var e = _ref.id,
      a = _ref.name,
      t = _ref.value,
      _ref$label = _ref.label,
      l = _ref$label === void 0 ? {
    label: "",
    subLabel: "",
    labelDescription: ""
  } : _ref$label,
      r = _ref.checked,
      n = _ref.disabled,
      o = _ref.onChange,
      _ref$displaySeparator = _ref.displaySeparator,
      c = _ref$displaySeparator === void 0 ? !1 : _ref$displaySeparator;
  return React.createElement(S.Wrapper, {
    selected: r,
    displaySeparator: c
  }, React.createElement(S.RadioButtonWrapper, null, React.createElement(S.StyledRadioButton, {
    type: "radio",
    id: e,
    name: a,
    value: t,
    checked: r,
    disabled: n,
    "data-testid": e + "-radio-button",
    onChange: function onChange(e) {
      o && o(e.target.id);
    }
  })), React.createElement(S.LabelWrapper, {
    as: "div",
    onClick: function onClick() {
      return a = e, void (o && o(a));
      var a;
    }
  }, React.createElement(S.Label, null, l.label), React.createElement(S.SubLabel, null, l.subLabel), React.createElement(S.LabelDescription, null, l.labelDescription)));
}
export default FormOption;